import React from 'react';
import { PlaidLinkOnSuccessMetadata } from 'react-plaid-link';
import PlaidLink from 'src/apps/invest/common/components/PlaidLink';
import { useBankAccountsModel } from '@common/models/BankAccountsModel';

type VerifyAccountButtonProps = {
  accountID: string;
};

export const VerifyAccountButton: React.FC<VerifyAccountButtonProps> = ({ accountID }) => {
  const model = useBankAccountsModel();

  const onVerifySuccess = async (publicToken: string, metadata: PlaidLinkOnSuccessMetadata) => {
    const status = await model.finishVerification(publicToken, metadata);
    if (!status.success) {
      alert(status.error);
    }
  };

  return (
    <PlaidLink
      onSuccess={onVerifySuccess}
      buttonProps={{
        children: 'Verify',
        colorScheme: "red",
        size: 'sm',
        variant: 'outline',
      }}
      currentBankAccountId={accountID}
    />
  );
};
